import { FC } from "react";
import { Styled } from "./styled";
import useText, { IProps } from "./hook";

const TextLayout = (props: ReturnType<typeof useText>) => {
  const { text } = props;

  return (
    <Styled>
      <div
        style={{
          width: "100%",
          height: "calc(100% - 40px)",
          overflow: "auto",
        }}
      >
        <pre>{text}</pre>
      </div>
    </Styled>
  );
};

const Text: FC<IProps> = (props: IProps) => <TextLayout {...useText(props)} />;

export default Text;
